const prefix = 'ATTACH_ACCOUNT';

export const SET_OBJECT_NAME = `${prefix}_SET_OBJECT_NAME`;
export const SET_SEARCH_KEY = `${prefix}_SET_SEARCH_KEY`;
export const SET_SEARCH_RESULTS = `${prefix}_SET_SEARCH_RESULTS`;
export const SET_SELECTED_ACCOUNT_ID = `${prefix}_SET_SELECTED_ACCOUNT_ID`;
export const RESET = `${prefix}_RESET`;




// WEBPACK FOOTER //
// ./src/views/AttachAccount/flow/actionTypes.js